<template lang="pug" src="./tabs-home.pug"></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// tabs-home.vue?3beb740a